type NumberSelector<T> = (t: T) => number;
type StringSelector<T> = (t: T) => string;
type Selector<T> = NumberSelector<T> | StringSelector<T>;

export function sortBy<T>(list: T[], selector: Selector<T>): T[] {
  const listShallowCopy = [...list];
  listShallowCopy.sort((a, b) => {
    if (selector(a) === selector(b)) return 0;
    return selector(a) > selector(b) ? 1 : -1;
  });

  return listShallowCopy;
}
